<template>
    <div>
        <div class="ui segment">
            <div class="ui top attached label">Authorized Applications</div>

            <p v-if="tokens.length === 0">
                You don't have any authorized applications.
            </p>

            <table class="ui very basic striped table" v-if="tokens.length > 0">
                <thead>
                    <tr>
                        <th>Name</th>
                        <th>Scopes</th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="token in tokens" :key="token.id">
                        <td>
                            {{ token.client.name }}
                        </td>

                        <td>
                            <span v-if="tokens.scopes.length > 0">
                                {{ tokens.scopes.join(', ') }}
                            </span>
                        </td>

                        <td>
                            <button class="ui red button" @click="promptRevoke(token)">
                                Revoke
                            </button>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>

        <div class="ui basic modal" id="modal-destroy-token" tabindex="-1" role="dialog">
            <div class="ui icon header">
                <i class="outline trash icon"></i>
                Revoke Client Access?
            </div>

            <div class="content">
                <p>Are you sure you want to revoke access for {{ destroyToken.name }}? This action cannot be undone.</p>
            </div>

            <div class="actions">
                <button class="ui grey cancel basic inverted button">
                    No
                </button>

                <button class="ui ok red inverted button" @click="revoke()">
                    Revoke
                </button>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        /*
         * The component's data.
         */
        data() {
            return {
                tokens: [],

                destroyToken: {
                    name: '',
                    id: 0
                }
            };
        },

        /**
         * Prepare the component (Vue 1.x).
         */
        ready() {
            this.prepareComponent();
        },

        /**
         * Prepare the component (Vue 2.x).
         */
        mounted() {
            this.prepareComponent();
        },

        methods: {
            /**
             * Prepare the component (Vue 2.x).
             */
            prepareComponent() {
                this.getTokens();
            },

            /**
             * Get all of the authorized tokens for the user.
             */
            getTokens() {
                this.$http.get('/oauth/tokens')
                        .then(response => {
                            this.tokens = response.data;
                        });
            },

            promptRevoke(token) {
                this.destroyToken.name = token.client.name;
                this.destroyToken.id = token.id;

                $('#modal-destroy-token').modal('show');
            },

            /**
             * Revoke the given token.
             */
            revoke() {
                axios.delete('/oauth/tokens/' + this.destoryToken.id)
                        .then(response => {
                            this.destroyToken.id = 0;
                            this.destroyToken.name = '';

                            this.getTokens();
                        });
            }
        }
    }
</script>
